import { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import api from "../api/axios";

export default function ConductoresTab({ vehicleId }) {
  const [drivers, setDrivers] = useState([]);
  const [persons, setPersons] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState("");

  const [loadingList, setLoadingList] = useState(false);       // 🔵 Spinner al cargar lista
  const [loadingAssign, setLoadingAssign] = useState(false);   // 🟡 Spinner asignando
  const [loadingRemove, setLoadingRemove] = useState(null);    // 🔴 Spinner quitando (toma el id)

  // Cargar conductores asignados
  const fetchDrivers = async () => {
    try {
      setLoadingList(true);
      const res = await api.get(`/vehicles/${vehicleId}/persons`);
      setDrivers(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingList(false);
    }
  };

  // Cargar todas las personas (solo conductores)
  const fetchPersons = async () => {
    try {
      const res = await api.get(`/persons/list`);
      const onlyDrivers = res.data.data.filter((p) => p.is_driver);
      setPersons(onlyDrivers);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchPersons();
    fetchDrivers();
  }, []);

  // ========================
  // ASIGNAR
  // ========================
  const assignDriver = async () => {
    setLoadingAssign(true);
    try {
      await api.post(`/vehicles/${vehicleId}/assign-person`, {
        person_id: selectedPerson,
      });

      setSelectedPerson("");
      fetchDrivers();
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.response?.data?.message || "Error asignando conductor",
        icon: "error",
        showConfirmButton: true,
      });
    } finally {
      setLoadingAssign(false);
    }
  };

  // ========================
  // REMOVER
  // ========================
  const removeDriver = async (personId) => {
    setLoadingRemove(personId); // activa spinner solo en ese ítem
    try {
      await api.delete(`/vehicles/${vehicleId}/remove-person/${personId}`);
      fetchDrivers();
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.response?.data?.message || "Error removiendo conductor",
        icon: "error",
        showConfirmButton: true,
      });
    } finally {
      setLoadingRemove(null);
    }
  };

  return (
    <div>
      <h6>Asignar nuevo conductor</h6>

      <div className="d-flex gap-2">
        <Form.Select
          value={selectedPerson}
          onChange={(e) => setSelectedPerson(e.target.value)}
        >
          <option value="">Seleccionar...</option>
          {persons.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name} – {p.document_num}
            </option>
          ))}
        </Form.Select>

        <Button onClick={assignDriver} disabled={!selectedPerson || loadingAssign}>
          {loadingAssign ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
            </>
          ) : (
            "Asignar"
          )}
        </Button>
      </div>

      <br />

      <h5>Conductores asignados</h5>

      {/* Spinner al cargar lista */}
      {loadingList && (
        <div className="text-center my-3">
          <Spinner animation="border" variant="primary" />
          <p className="text-muted mt-2">Cargando conductores...</p>
        </div>
      )}

      {!loadingList && drivers.length === 0 && (
        <p className="text-muted">No hay conductores asignados.</p>
      )}

      <ul className="list-group mb-3">
        {!loadingList &&
          drivers.map((d) => (
            <li
              key={d.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <span>
                {d.name} ({d.document_num})
              </span>

              <Button
                variant="outline-danger"
                size="sm"
                disabled={loadingRemove === d.id}
                onClick={() => removeDriver(d.id)}
              >
                {loadingRemove === d.id ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" />
                    Quitando...
                  </>
                ) : (
                  "Quitar"
                )}
              </Button>
            </li>
          ))}
      </ul>
    </div>
  );
}
